/**
 配置信息--模块管理
 */
import React, { PureComponent } from "react";
// import {Tooltip} from 'antd';
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import fetchHandler from "@/fetch/fetchHandler";
import PropTypes from "prop-types";
import RefreshGrid from "../../../utils/refreshGrid";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { Modal } from "antd";
// 引入组件
import ModalStruts from "./modalStruts";
// 国际化切换语言
import {
  powerModuleInfo,
  getModuleMsgList,
  prefixFile,
  getCityList,
} from "../../../fetch/fetchApi";
import { useAuth } from "@/utils/utils";

@connect((state) => state)
class ModuleList extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.moduleList;
    this.state = {
      visible: false,
      seeModuleInfoVisible: false,
      stateList: [
        {
          text: this.internationalization.state1, // '全部',
          value: "0",
        },
        {
          text: this.internationalization.state2, // '正常',
          value: "1",
        },
        {
          text: this.internationalization.state3, // '故障',
          value: "2",
        },
      ],
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.getCityList();
    this.init();
  }

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.placeholder1, // '请输入模块编号',
          param: {
            name: "sn",
            type: "string",
          },
          labelName: this.internationalization.title2, // '模块编号:',
          required: false,
        },
        {
          type: "input",
          placeholder: this.internationalization.placeholder2, // '请输入设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: this.internationalization.title1, // '设备编号:',
          required: false,
        },
        {
          type: "input",
          placeholder: this.internationalization.placeholder4, // '请输入电站名称',
          param: {
            name: "stationName",
            type: "string",
          },
          labelName: this.internationalization.wz4, // '电站名称:',
          required: false,
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },
        {
          type: "select",
          placeholder: this.internationalization.placeholder3, // '请选择',
          param: {
            name: "validStatus",
            type: "number",
          },

          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "有效",
              value: 1,
            },
            {
              text: "无效",
              value: 0,
            },
            {
              text: "未知",
              value: 2,
            },
          ],

          labelName: "有效状态",
          required: false,
        },
        {
          type: "select",
          placeholder: this.internationalization.placeholder3, // '请选择',
          param: {
            name: "moduleStatus",
            type: "string",
          },

          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "正常",
              value: "00",
            },
            {
              text: "故障",
              value: "01",
            },
            {
              text: "不可识别",
              value: "02",
            },
            {
              text: "输出功率不足",
              value: "03",
            },
          ],

          labelName: "模块状态",
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("010501")
              ? {
                  btnType: "submit",
                  icon: "search",
                  text: this.internationalization.btn1, // '查询'
                }
              : "",

            useAuth("010502")
              ? {
                  btnType: "button",
                  text: "导出", // '导出',
                  handler: (e, param) => {
                    const newParam = param;
                    newParam.flag = 1;
                    newParam.token = window.sessionStorage.getItem("token");
                    let paramString = "";
                    if (newParam.cityGroup == null || newParam.cityGroup.length == 0) {
                      newParam.cityIds = "";
                    } else {
                      newParam.cityIds = newParam.cityGroup.join(",");
                    }
                    Object.keys(newParam).forEach((key) => {
                      const paraminfo = newParam[key] ? newParam[key] : "";
                      paramString += `${key}=${paraminfo}&`;
                    });
                    this.exportOrderStuGroup(paramString);
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: 1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "ModuleListTable",
      tablePage: "模块管理",
    };
    this.setState({
      tableConfig: {
        tableKey: "ModuleListTable",
        tableColumns: [
          {
            name: this.internationalization.title2, // '模块编号',
            key: "sn",
            colType: "textCol",
            align: "left",
          },
          {
            name: "槽位",
            key: "slot",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              return row.slot === "" || null ? "--" : row.slot
            }
          },
          {
            name: "有效状态",
            key: "validStatusName",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              return row.validStatusName === "" || null ? "--" : row.validStatusName
            }
          },
          {
            name: this.internationalization.title3, // '设备编号',
            key: "stubId",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              if (value !== "总计") {
                const time = row.modifyTime.split(" ")[0];
                return (
                  <div>
                    <a
                      onClick={() => {
                        this.openTab(
                          {
                            keyId: `moduleInfo`,
                            stubId: row.stubId,
                            createTime: time,
                            subjectSerial: row.sn,
                          },
                          {
                            key: "moduleInfo",
                            titleText: "模块信息",
                          },
                        );
                      }}>
                      {value}
                    </a>
                  </div>
                );
              } else {
                return value;
              }
            },
          },
          {
            name: "设备型号",
            key: "modelNo",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.internationalization.wz4, // '场站名称',
            colType: "tipCol",
            key: "stubGroupName",
            align: "left",
            // render:(value,row,index)=>{
            //     if(value != ''){
            //          const msg = row.msg.length > 10 ? (<Tooltip title= {row.msg}>
            // {row.msg.substring(0,10)+'……'}</Tooltip>) : (<div>{row.msg}</div>)
            //          return msg
            //     }else{
            //         return '--'
            //     }
            // }
          },
          {
            name: this.internationalization.areaName, // '地区',
            colType: "tipCol",
            key: "cityName",
            align: "left",
            // render:(value,row,index)=>{
            //     if(value != ''){
            //          const msg = row.msg.length > 10 ? (<Tooltip title= {row.msg}>
            // {row.msg.substring(0,10)+'……'}</Tooltip>) : (<div>{row.msg}</div>)
            //          return msg
            //     }else{
            //         return '--'
            //     }
            // }
          },
          {
            name: "模块状态",
            key: "statusName",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              return row.statusName === "" || null ? "--" : row.statusName
            }
          },
          {
            name: this.internationalization.wz2, // '运行时长',
            key: "runtime",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              const timeInfo = this.handleSecord(row.runtime);
              const msg = <div>{timeInfo}</div>;

              return msg;
            },
          },
          {
            name: "更新时间",
            key: "modifyTime",
            colType: "textCol",
            align: "left",
          },
          {
            name: "预警类型",
            key: "warnTypeName",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            width: 100,
            colType: "action",
            actionMap: [
              useAuth("010503")
                ? {
                    type: "href",
                    actionName: this.internationalization.modalTitle1, // '历史设备',
                    handler: (record) => {
                      // 通过查询，获取模块信息
                      this.openTab(
                        {
                          keyId: `moduleDetail`,
                          sn: record.sn,
                        },
                        {
                          key: "moduleDetail",
                          titleText: this.internationalization.modalTitle1, // '历史设备',
                        },
                      );
                    },
                  }
                : "",
              useAuth("010504")
                ? {
                    type: "href",
                    actionName: this.internationalization.wz3, // '故障日志',
                    handler: (record) => {
                      this.setState(
                        {
                          sn: record.sn,
                        },
                        () => {
                          // 通过查询，获取模块状态日志
                          this.modalVisibleAction("seeModuleInfoVisible", true);
                        },
                      );
                    },
                  }
                : "",
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          flag: "1",
        },
        dataApi: powerModuleInfo,
        autoRefresh: 1, // 设置为true 直接加载grid数据
      },
    });
  }

  exportOrderStuGroup = (paramString) => {
    const excelUrl = `${prefixFile}/exportPowerModuleInfo.do`;

    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return (
        day +
        this.internationalization.dw +
        hour +
        this.internationalization.hour +
        minute +
        this.internationalization.minute +
        second +
        this.internationalization.second
      );
    } else if (hour > 0) {
      return (
        hour +
        this.internationalization.hour +
        minute +
        this.internationalization.minute +
        second +
        this.internationalization.second
      );
    } else if (minute > 0) {
      return minute + this.internationalization.minute + second + this.internationalization.second;
    } else {
      return second + this.internationalization.second;
    }
  }

  /**
   * 开启/关闭 模态弹窗
   */
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList, { userId: sessionStorage.getItem("userId") }).then((res) => {
      if (!res.data) {
        return;
      }
      const fetchPickerOptions = res.data;
      let formatOptionsStr = JSON.stringify(fetchPickerOptions);
      formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
      const cityAryy = JSON.parse(formatOptionsStr);
      cityAryy.map((item) => {
        item.key = item.value;
        item.children.map((item2) => {
          item2.key = item2.value;
          delete item2.children; // 删除子区域数据
          return true;
        });
        return true;
      });
      // 初始化城市数据
      // this.quanguoCityArry = [
      //   {
      //     title: "全国",
      //     value: "000000",
      //     key: "000000",
      //     children: JSON.parse(JSON.stringify(cityAryy)),
      //   },
      // ];

      this.quanguoCityArry = JSON.parse(JSON.stringify(cityAryy));
      // 只能选择城市的方式
      this.quanguoCityNotP = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotP.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = false;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择省份的数组
      this.quanguoCityNotCity = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotCity.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = false;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择全国的数组
      this.quanguoCityNotChild = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotChild.map((item) => {
        item.disabled = false;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 设置数据
      // console.log(1111);
      // console.log(this.quanguoCityArry);
      // console.log(1111);
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.init(),
          });
        },
      );
    });
  };

  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.init(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = "";
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (
        value[0].charAt(5) === "0" &&
        value[0].charAt(4) === "0" &&
        value[0].charAt(3) === "0" &&
        value[0].charAt(2) === "0"
      ) {
        quanguoCityArryCVal = this.quanguoCityArry;
      } else {
        quanguoCityArryCVal = this.quanguoCityArry;
      }
      // 设置数据
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.init(),
          });
        },
      );
    }
  };

  /**
   * 表格数据加载方法
   */
  fetchApi = (param) => {
    // console.info("哎哎");
    // console.info(param);
    const newParam = param;
    const cityGroup = param.cityGroup;
    // 设置年、月参数
    if (param.cityGroup == null || param.cityGroup.length == 0) {
      newParam.cityIds = "";
    } else {
      newParam.cityIds = param.cityGroup.join(",");
    }
    delete newParam.cityGroup;
    // 加载表格
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "ModuleListTable", newParam);
    }
  };

  /**
   * 开启新开页
   */
  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>

        <Modal
          title={this.internationalization.wz3}
          visible={this.state.seeModuleInfoVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeModuleInfoVisible", false);
          }}>
          <ModalStruts
            sn={this.state.sn}
            onAdd={this.props.onAdd}
            onCancel={() => {
              this.modalVisibleAction("seeModuleInfoVisible", false);
            }}
          />
        </Modal>
      </div>
    );

    return Content;
  }
}

export default injectIntl(ModuleList);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/module/moduleList.js